package com.cs.ejobin.data.supabase

import com.cs.ejobin.data.AvatarRepository
import io.github.jan.supabase.SupabaseClient
import io.github.jan.supabase.auth.auth
import io.github.jan.supabase.storage.storage
import io.ktor.http.ContentType
import kotlin.random.Random

class SupabaseAvatarRepository(
    private val supabase: SupabaseClient
) : AvatarRepository {

    private val bucket = "avatars"

    override suspend fun uploadMyAvatar(
        bytes: ByteArray,
        contentType: String,
        fileExt: String
    ): String {
        val userId = supabase.auth.currentUserOrNull()?.id
            ?: error("Utilisateur non authentifié")

        val safeExt = fileExt.trim().trimStart('.').ifBlank { "jpg" }
        val path = "$userId/avatar_${Random.nextInt(100000, 999999)}.$safeExt"

        val ct: ContentType = when (safeExt) {
            "png" -> ContentType.Image.PNG
            "webp" -> ContentType.parse("image/webp")
            "jpg", "jpeg" -> ContentType.Image.JPEG
            else -> ContentType.Image.JPEG
        }

        supabase.storage
            .from(bucket)
            .upload(path, bytes) {
                upsert = true
                this.contentType = ct
            }

        return supabase.storage.from(bucket).publicUrl(path)
    }
}